var R = /* @__PURE__ */ ((A) => (A.POUAN = "POUAN", A.ABR_HAMRAHI = "ABR_HAMRAHI", A.STANDARD = "STANDARD", A))(R || {});
export {
  R as VODProviderType
};
